import { rest } from 'msw'
import type { ContactPaymentInstruments } from 'types/contacts'
import confirmPayeeResponses from '../../../__mocks__/FiatSend/confirmPayeeResponses.json'
import feeEstimateResponse from '../../../__mocks__/FiatSend/feeEstimateResponse.json'
import { createPaymentInstrumentsResponse } from '../contacts/contactHandlers'

export const FEE_ESTIMATE_RESPONSE = feeEstimateResponse

export const CONFIRM_PAYEE_MATCH = confirmPayeeResponses.match
export const CONFIRM_PAYEE_PARTIAL_MATCH = confirmPayeeResponses.partialMatch
export const CONFIRM_PAYEE_NOT_POSSIBLE = confirmPayeeResponses.notPossible
export const CONFIRM_PAYEE_NOT_REQUIRED = confirmPayeeResponses.notRequired

export const feeEstimateHandler = (response = FEE_ESTIMATE_RESPONSE) =>
  rest.post('*/payment/v2/payouts/fee-estimation', (_req, res, ctx) => res(ctx.json(response)))

export const feeEstimateDelayedHandler = (delayMs = 200, response = FEE_ESTIMATE_RESPONSE) =>
  rest.post('*/payment/v2/payouts/fee-estimation', (_req, res, ctx) =>
    res(ctx.delay(delayMs), ctx.json(response))
  )

export const feeEstimateErrorHandler = (errorBody: Record<string, unknown>, status = 400) =>
  rest.post('*/payment/v2/payouts/fee-estimation', (_req, res, ctx) =>
    res(ctx.status(status), ctx.json(errorBody))
  )

export const confirmPayeeHandler = (response = CONFIRM_PAYEE_NOT_REQUIRED) =>
  rest.post('*/platform/v1/beneficiaries/verification', (_req, res, ctx) => res(ctx.json(response)))

export const confirmPayeeDelayedHandler = (delayMs = 500) =>
  rest.post('*/platform/v1/beneficiaries/verification', (_req, res, ctx) =>
    res(ctx.delay(delayMs), ctx.json(CONFIRM_PAYEE_NOT_REQUIRED))
  )

export const confirmPayeeErrorHandler = () =>
  rest.post('*/platform/v1/beneficiaries/verification', (_req, res, ctx) =>
    res(ctx.status(500), ctx.json({ error: 'Internal Server Error' }))
  )

export const contactInstrumentsHandler = (contacts: ContactPaymentInstruments[] = []) =>
  rest.get('*/platform/v2/payment-instruments', (_req, res, ctx) =>
    res(ctx.json(createPaymentInstrumentsResponse(contacts)))
  )

export const contactInstrumentsErrorHandler = () =>
  rest.get('*/platform/v2/payment-instruments', (_req, res, ctx) =>
    res(ctx.status(500), ctx.json({ error: 'Internal Server Error' }))
  )

export const fiatSendHandlers = [feeEstimateHandler(), confirmPayeeHandler()]
